import React, { useState, useEffect } from 'react';
import * as Icons from 'lucide-react';
import { ExternalLink, Loader2 } from 'lucide-react';

const Procedimentos = ({ copy }) => {
  const [dados, setDados] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetch('/api/procedimentos')
      .then(res => res.json())
      .then(res => {
        setDados(res);
        setLoading(false);
      })
      .catch(err => console.error("Erro ao carregar:", err));
  }, []);

  const getStyle = (cor) => {
    const config = {
      red: "text-red-600 dark:text-red-500 border-red-500/20 bg-red-50/50 dark:bg-red-500/10 glow-red",
      emerald: "text-emerald-600 dark:text-emerald-500 border-emerald-500/20 bg-emerald-50/50 dark:bg-emerald-500/10 glow-emerald",
      amber: "text-amber-600 dark:text-amber-500 border-amber-500/20 bg-amber-50/50 dark:bg-amber-500/10 glow-amber",
      blue: "text-blue-600 dark:text-blue-500 border-blue-500/20 bg-blue-50/50 dark:bg-blue-500/10 glow-blue",
      orange: "text-orange-600 dark:text-orange-500 border-orange-500/20 bg-orange-50/50 dark:bg-orange-500/10 glow-orange",
      pink: "text-pink-600 dark:text-pink-500 border-pink-500/20 bg-pink-50/50 dark:bg-pink-500/10 glow-pink",
      purple: "text-purple-600 dark:text-purple-500 border-purple-500/20 bg-purple-50/50 dark:bg-purple-500/10 glow-purple"
    };
    return config[cor] || config.blue;
  };

  if (loading) return (
    <div className="flex flex-col items-center justify-center p-20 gap-4">
      <Loader2 className="animate-spin text-blue-500" size={40} />
      <p className="text-slate-500 font-bold animate-pulse uppercase text-[10px] tracking-[0.2em]">Sincronizando Procedimentos...</p>
    </div>
  );

  return (
    <div className="max-w-5xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 pb-20 animate-in fade-in duration-700">
      
      {dados.map((item) => {
        const IconeComp = Icons[item.icone] || Icons.HelpCircle;
        const estiloClasses = getStyle(item.cor);
        const corTexto = estiloClasses.split(' ')[0];
        
        const listaItens = typeof item.dados_json === 'string' 
          ? JSON.parse(item.dados_json) 
          : item.dados_json;

        return (
          <div key={item.id} className="group relative">
            {/* EFEITO GLOW DE FUNDO */}
            <div className={`absolute -inset-0.5 bg-gradient-to-r from-transparent via-${item.cor}-500/20 to-transparent rounded-[48px] blur-xl opacity-0 group-hover:opacity-100 transition duration-700`}></div>
            
            {item.tipo === 'link' ? (
              <a href={item.url} target="_blank" rel="noopener noreferrer"
                 className={`relative block bg-white dark:bg-slate-900 p-8 rounded-[48px] border-2 border-slate-200 dark:border-slate-800 space-y-6 shadow-2xl transition-all duration-300 hover:scale-[1.02] group no-underline hover:border-${item.cor}-500/50`}>
                <div className="flex items-center justify-between">
                  <h3 className={`${corTexto} font-black text-xs tracking-widest flex items-center gap-4`}>
                    <IconeComp size={18} className="group-hover:rotate-12 transition-transform" /> {item.titulo}
                  </h3>
                  <div className="bg-slate-100 dark:bg-slate-800 p-2 rounded-2xl group-hover:bg-blue-500 group-hover:text-white transition-all">
                    <ExternalLink size={18} />
                  </div>
                </div>
                <div className="flex flex-col gap-1">
                  <p className="text-slate-900 dark:text-white font-black text-lg group-hover:translate-x-1 transition-transform">{item.descricao}</p>
                  <p className="text-slate-500 text-xs font-bold uppercase tracking-tighter">{item.sub_titulo}</p>
                </div>
              </a>
            ) : (
              <div className={`relative bg-white dark:bg-slate-900 p-8 rounded-[48px] border-2 border-slate-200 dark:border-slate-800 space-y-6 shadow-2xl overflow-hidden transition-all duration-300 group-hover:border-${item.cor}-500/50`}>
                <div className="absolute -top-4 -right-4 opacity-5 dark:opacity-10 pointer-events-none group-hover:scale-110 transition-transform duration-700">
                  <IconeComp size={100} />
                </div>
                
                <h3 className={`${corTexto} font-black text-xs tracking-widest flex items-center gap-4 relative z-10 uppercase`}>
                  <IconeComp size={18}/> {item.titulo}
                </h3>

                <div className="space-y-3 relative z-10">
                  {listaItens?.map((sub, idx) => (
                    <div key={idx} 
                         onClick={() => copy(sub.valor, sub.label)}
                         className={`p-4 rounded-2xl border transition-all cursor-pointer active:scale-95 ${
                           sub.destaque 
                           ? estiloClasses + " border-transparent shadow-lg shadow-black/5" 
                           : 'bg-slate-50 dark:bg-slate-950 border-slate-200 dark:border-slate-800 hover:bg-white dark:hover:bg-slate-900 hover:shadow-md'
                         }`}>
                      <p className={`text-[9px] font-black mb-1 tracking-widest uppercase ${sub.destaque ? corTexto : 'text-slate-400'}`}>
                        {sub.label}
                      </p>
                      <p className={`font-mono font-black break-all ${sub.destaque ? 'text-lg ' + corTexto : 'text-sm text-slate-900 dark:text-white'}`}>
                        {sub.valor}
                      </p>
                      {sub.sub && <p className="text-[8px] text-slate-500 mt-2 font-bold uppercase leading-tight">{sub.sub}</p>}
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        );
      })}
    </div>
  );
};

export default Procedimentos;